import { useEffect, useRef } from "react";

function useOnClickOutside2(handler, open = true, event = "mousedown") {
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event?.target)) return;
      handler();
    };

    document.addEventListener(event, listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener(event, listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [handler, ref, open, event]);

  return ref;
}

export default useOnClickOutside2;
